"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalSaveSuccessModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
require("react-datepicker/src/stylesheets/datepicker.scss");
var StorageSuccessModal_1 = require("../../../../components/modals/StorageSuccessModal");
var commonFunctions_1 = require("../../../../commonFunctions");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@athena-portal/components");
var moment = require("moment");
var RenewalSaveSuccessModalWidget = /** @class */ (function (_super) {
    __extends(RenewalSaveSuccessModalWidget, _super);
    function RenewalSaveSuccessModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            partyLoaded: false,
            mainCardIdLoaded: false
        };
        return _this;
    }
    RenewalSaveSuccessModalWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getProfile().subscribe(function (output) {
            _this.setState({
                party: output,
                partyLoaded: true
            });
        });
        this.customerPortalService.getPolicyPropertyByPropertyKey(this.props.interaction.agreementNumber, services_1.MAIN_ANNUAL_PAYMENT_CARD).subscribe(function (property) {
            _this.setState({
                mainCardId: property.value,
                mainCardIdLoaded: true
            });
        });
    };
    RenewalSaveSuccessModalWidget.prototype.render = function () {
        var loading = !this.state.partyLoaded || !this.state.mainCardIdLoaded;
        if (!loading) {
            var premiumToDisplay = void 0;
            var premiumType = this.props.interaction.factors.premiumType;
            if (premiumType === services_1.PREMIUM_TYPE_ANNUAL) {
                premiumToDisplay = this.props.interaction.factors.annualPremium;
            }
            else {
                premiumToDisplay = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
            }
            this.showSuccessPopup = window.sessionStorage.getItem("showPopup");
            this.title = (0, jsx_runtime_1.jsx)("h1", { children: "All done!" });
            var paymentCard = (0, commonFunctions_1.findMainAnnualPaymentCard)(this.state.party, this.state.mainCardId);
            var startDate = moment(this.props.interaction.headerInfo.startDate).format("DD MMMM YYYY");
            var monthlyPayerInitialPaymentDate = moment.utc(this.props.interaction.renewalDetails.monthlyPayerInitialPaymentDate, moment.ISO_8601).format("DD MMM YYYY");
            this.modalContent =
                (0, jsx_runtime_1.jsxs)("div", { className: 'renewal-save-change-success-modal', children: [(0, jsx_runtime_1.jsxs)("p", { className: 'sub-header', children: ["You made changes to your", " ", this.props.interaction.vehicles[0].make, " ", this.props.interaction.vehicles[0].model, "\u2019s "] }), premiumType === services_1.PREMIUM_TYPE_ANNUAL &&
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: 'price-section', children: ["Your new car insurance renewal price is ", (0, jsx_runtime_1.jsx)("span", { className: 'price-bold', children: (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay) })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'card-section', children: [" and will be taken from your card ending in ", (0, jsx_runtime_1.jsx)("span", { className: 'card-number-bold', children: paymentCard && paymentCard.cardNumberObfuscated.split('******')[1] }), " on ", startDate, "."] })] }), premiumType === services_1.PREMIUM_TYPE_MONTHLY &&
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: 'price-section', children: ["Your 1st payment of ", ' ', (0, jsx_runtime_1.jsx)("span", { className: 'price-bold', children: (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay) })] }), " will be taken from card ending in ", ' ', (0, jsx_runtime_1.jsx)("span", { className: 'card-number-bold', children: paymentCard.cardNumberObfuscated.split('******')[1] }), " on ", monthlyPayerInitialPaymentDate, ". Please check your payment plan for further dates and amounts."] }), " ", "Please ", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "check-your-card-link", to: "/dashboard/annualPaymentHistory", onClick: function () { return window.sessionStorage.removeItem("showPopup"); }, children: "check your payment card" }), " is still valid."] });
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!loading && this.showSuccessPopup &&
                    (0, jsx_runtime_1.jsx)(StorageSuccessModal_1.StorageSuccessModal, { cssClass: "renewal-save-changes-success-modal", title: this.title, explanationWording: this.modalContent }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: loading })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], RenewalSaveSuccessModalWidget.prototype, "customerPortalService", void 0);
    return RenewalSaveSuccessModalWidget;
}(plugin_journey_1.WidgetBase));
exports.RenewalSaveSuccessModalWidget = RenewalSaveSuccessModalWidget;
//# sourceMappingURL=RenewalSaveSuccessModalWidget.js.map